export default __webpack_public_path__ + "static/media/production.1f2ded3b.svg";